<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Helpful Hints">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e32" xmlns:saxon="http://icl.com/saxon">Helpful Hints</a></h1><a id="d0e32" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e32" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e32" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e32" xmlns:saxon="http://icl.com/saxon">
<p>1. Use your Dutch oven year round—just put it anywhere it will be protected from wind, such
        as a patio, garage, or even the oven. Wind carries the heat away, so it is important to be
        in a wind free area.</p>
<p>2. Charcoal briquettes are used in all recipes of this book. If cooking in your home oven,
        simply place Dutch oven inside without the coals and set your oven temperature as listed in
        the recipe. </p>
<p>3. When purchasing a Dutch oven, look for lumps in the casting. Lumps cause hot spots you
        want to avoid. Look at the thickness of all sides of a Dutch oven. If one side is thinner
        than the other, it will not cook evenly and your results will be poor. Also, make sure the
        lid sits flat and does not rock to ensure there is a good seal when cooking. However, if the
        lid moves side to side slightly, that is fine. </p>
<p>4. All Dutch ovens come with a wax on them to protect during shipping (unless it has been
        preseasoned). To season a new Dutch oven, scrub off all the wax and then coat with
        shortening. Place Dutch oven upside down in a barbecue or an oven (to allow shortening to
        drip off when heating), and heat to 400 degrees for 30 minutes. This begins to make the
        nonstick surface for which Dutch ovens are famous. Let the oven cool naturally, and when you
        can touch it with your hands, place the lid back on the Dutch oven and let it continue to
        cool. The more you use the oven, the more seasoned or nonstick it will become. Depending on
        the frequency of use, you may have to season several times a year. When the oven starts to
        smell rancid, do the whole seasoning process again. </p>
<p>5. When you clean a Dutch oven after it has been seasoned, don't use soap. The soap pulls
        the seasoning out and you will have to season it again. Use really hot water and a plastic
        scrubbing pad. Never use anything metal. Metal will scrape away the oven's nonstick surface. </p>
<p>6. Store a Dutch oven with something between the lid and the pot, such as a rolled up paper
        towel. This allows air to flow through it during storage and helps keep the oven from
        becoming rancid. If the oven gives off a funny pungent smell, you know it is rancid and
        needs to be seasoned again. If you use your oven year round, it will not become rancid. If
        your oven becomes rusty, you are not using it often enough. Scrub the rust off with an SOS
        pad, dry, and then season it again. </p>
<p>7. Heat control is important in a Dutch oven. Take the size of the oven, such as a 12-inch,
        then double that number to 24. This gives you the number of coals to start with to reach 350
        degrees of heat. A 14-inch would be 28, a 16-inch would be 32, and so on. Place 10 coals
        under the Dutch oven and put the rest on top. Each additional coal placed on the oven adds
        approximately 20 degrees. For baking, put most of the heat on the lid. For frying, put most
        of the heat on the bottom. You will almost never put a coal in the center of the oven
        (bottom or lid) as it will make a hot spot and burn food, causing poor results. </p>
<p>8. Experiment with your Dutch oven and get creative with your recipes. You may even want to
        enter a Dutch oven cook off. Look at the International Dutch Oven Society Web page for a
        cook off near you. </p>
<p>9. When cooking with a Dutch oven, be mindful of the size of your coals so your heat
        doesn't drop. When coals are the size of a quarter, it's time to replace them with new ones. </p>
<p>10. Rotate Dutch oven every 10 minutes by moving lid counterclockwise and bottom clockwise.
        This will help to cook more evenly, especially with cakes and breads. </p>
<p>11. Place moisture managers between the lid and the Dutch oven or use clothespins to help
        hold the lid ajar. This allows the moisture to escape as needed when reducing sauces or
        liquids in a recipe. </p>
<p>12. The Camp Chef Ultimate Dutch oven is a special Dutch oven that is designed for
        convection cooking. It has two racks, one on the bottom for cooking the meat, and one near
        the top for cooking vegetables, and many other uses, such as for cooking pies. They come in
        either aluminum or cast iron. </p>
</a></div><a id="d0e32" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?f8a6a80a